import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, clearAuthToken } from "@/lib/apiClient";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = authed
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      setUser(false);
      return false;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (payload) => {
    const { data } = await api.post("/auth/login", payload);
    setUser(data);
    return data;
  };

  const register = async (payload) => {
    const ref = localStorage.getItem("astra_ref");
    const { data } = await api.post("/auth/register", ref ? { ...payload, ref } : payload);
    localStorage.removeItem("astra_ref");
    setUser(data);
    return data;
  };

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    clearAuthToken();
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refresh, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
